import type { ComparisonFilterInput, NestedLogicalFilterInput } from '@hello-aria/query-string/dist/stringify'
import type { ResolveFilters, ResolveFiltersParams } from '@/shared/utils/resolveFiltersUtils'

export const resolveSubscriptionFilters = ({ customFilters }: ResolveFiltersParams): ResolveFilters => {
    const filters: (ComparisonFilterInput | NestedLogicalFilterInput)[] = customFilters ?? []

    return {
        type: 'logical',
        operator: 'and',
        filters
    }
}
